/*
 * @Description:
 * @version:
 * @Author: knight
 * @Date: 2022-02-08 17:01:41
 * @LastEditors: knight
 * @LastEditTime: 2022-02-09 14:43:11
 */
const Vue = require('vue');

import methods from './plugins/methods';
import baseUrl from './api/road';
import App from './App.vue';
import router from './router';
import store from './store';
import Mint from 'mint-ui';
import Vant from 'vant';
import 'vant/lib/index.css';
import components from './plugins/components';
import './plugins/initGlobalDirective';
import 'mint-ui/lib/style.css';
import './static/font/icon.css';
import './static/style/index.less';
import regexp from './helper/regexp';
// import '@/permission';

Vue.use(Mint);
Vue.use(Vant);
Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(methods);
Vue.prototype.$url = baseUrl['v0'];
Vue.prototype.$regexp = regexp
Vue.use(components);
var vm = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

router.afterEach((to, from) => {
  vm.$el.scrollTop = 0;
});
